import React, { FC } from 'react'
import { Flex } from 'rebass'
import { Spinner } from 'components/base/spinner/spinner'
import { H3 } from 'components/base/typography/headings'

interface Props {
	message: string
}

const SignupFormLoader: FC<Props> = ({ message }) => {
	return (
		<div>
			<Flex flexDirection="column" alignItems="center">
				<H3 mb="3rem">{message}</H3>
				<Spinner />
			</Flex>
		</div>
	)
}

export default SignupFormLoader
